import { jsxs as a, jsx as l } from "react/jsx-runtime";
import { s as g, e as o } from "./themes-5f0b3c3d.mjs";
import "react";
import { S as s } from "./types-b577bf77.mjs";
import { S as f } from "./warningFilled-691cfde1.mjs";
import { u as i } from "./index-6a632112.mjs";
function m({
  title: e,
  titleId: t,
  size: n,
  height: x,
  width: d,
  ...u
}) {
  const r = n ? s[n] : s.s;
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      height: n ? r : x || r,
      width: n ? r : d || r,
      "aria-labelledby": t,
      ...u,
      children: [
        e ? /* @__PURE__ */ l("title", { id: t, children: e }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#Warning_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M32.94 9c.54-1.08 1.8-1.8 3.06-1.8s2.52.72 3.06 1.8l28.8 50.4a3.27 3.27 0 0 1 0 3.6c-.54 1.08-1.8 1.8-3.06 1.8H7.2c-1.26 0-2.34-.72-3.06-1.8a3.27 3.27 0 0 1 0-3.6L32.94 9ZM64.8 61.2 36 10.8 7.2 61.2h57.6ZM37.62 46.8c.36-4.32 1.26-16.38 1.26-19.8v-1.8h-5.4V27c0 3.42.72 15.48 1.26 19.8h2.88ZM32.4 54c0-1.98 1.44-3.42 3.6-3.42s3.6 1.44 3.6 3.42c0 2.16-1.44 3.6-3.6 3.6s-3.6-1.44-3.6-3.6Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Warning_svg__a", children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M0 0h72v72H0z" }) }) })
      ]
    }
  );
}
const v = i(f)`
  color: ${({ theme: e }) => e.components.textInput.error.helper};
`, S = i(m)`
  color: ${({ theme: e }) => e.components.textInput.caution.helper};
`, $ = i.div`
  display: flex;
  flex-direction: column;
  gap: ${g["2x"]};
`, p = i.div`
  padding-top: 2px;
`, c = i.span`
  display: flex;
  gap: ${g["2x"]};
  text-align: left;
  word-break: break-word;
  flex: 1 0 0;
  color: ${({ $inputState: e, theme: t }) => t.components.textInput[e || "default"].helper};
  font-family: ${o.regular.S.fontFamily};
  font-size: ${o.regular.S.fontSize};
  font-style: normal;
  font-weight: ${o.regular.S.fontWeight};
  line-height: ${o.regular.S.lineHeight};
`, h = (e) => {
  e.stopPropagation();
}, b = ({ defaultProp: e, secondaryProp: t }) => (e && e.helperText || t && t?.helperText && t?.state !== "none") && /* @__PURE__ */ a($, { children: [
  e?.helperText && /* @__PURE__ */ l(
    c,
    {
      "data-testid": "helper-text_test",
      id: e.id,
      $inputState: "default",
      onClick: h,
      children: e.helperText
    }
  ),
  t?.state && t?.state !== "none" && /* @__PURE__ */ a(
    c,
    {
      ...t && {
        "aria-live": "polite",
        role: "alert"
      },
      "data-testid": "helper-text_test",
      id: t.id,
      $inputState: t.state,
      onClick: h,
      children: [
        t.state === "error" && /* @__PURE__ */ l(p, { children: /* @__PURE__ */ l(v, { size: "xxs", role: "img" }) }) || t.state === "caution" && /* @__PURE__ */ l(p, { children: /* @__PURE__ */ l(S, { size: "xxs", role: "img" }) }),
        t.helperText
      ]
    }
  )
] }) || null;
export {
  b as H
};
